module.exports = __webpack_public_path__ + "img/sec-17-hanhwa.b836a28e.svg";